var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13375 14H0.23125V4.65292H3.13375V14ZM1.68094 3.37789C0.752813 3.37789 0 2.60912 0 1.68097C6.64312e-09 1.23515 0.177098 0.80759 0.492335 0.492346C0.807572 0.177102 1.23513 0 1.68094 0C2.12675 0 2.5543 0.177102 2.86954 0.492346C3.18478 0.80759 3.36188 1.23515 3.36188 1.68097C3.36188 2.60912 2.60875 3.37789 1.68094 3.37789ZM13.9969 14H11.1006V9.4499C11.1006 8.3655 11.0787 6.97484 9.59156 6.97484C8.0825 6.97484 7.85125 8.15299 7.85125 9.37177V14H4.95188V4.65292H7.73562V5.92794H7.77625C8.16375 5.19355 9.11031 4.41854 10.5225 4.41854C13.46 4.41854 14 6.35295 14 8.86551V14H13.9969Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.7f5079eab913b348ae53e2b70043f980.svg";
export { ForwardRef as ReactComponent };